import { useEffect } from 'react';

// eslint disabled because this is a custom hook, so the static checking doesn't work quite right.
export const useAsyncEffect = (func: () => Promise<void>, changeArray: any[]) => {
  useEffect(() => {
    // eslint-disable-next-line
    func();
    // eslint-disable-next-line
  }, changeArray);
};
